import { getStoryBySlug } from '@cinch-nx/data-storyblok'
import { traceFunction } from '@core/datadog-server'
import { GetStaticProps, InferGetStaticPropsType } from 'next'
import { BrandPageStory } from './storyblok/storyblok'
import { GetStaticPropsContext } from 'next'

const getStory = async (preview: boolean, slug: string) =>
  await getStoryBySlug<BrandPageStory>(`brands/${slug}`, {
    version: preview ? 'draft' : 'published',
    resolve_relations:
      'CarsCarousel.financeRepresentativeExample,FinanceOffersCarousel.financeRepresentativeExample',
  })

const getStoryProps = async (slug: string, preview = false) => {
  try {
    const story = await getStory(preview, slug)

    return {
      props: {
        story,
        preview,
        layoutProps: {
          heroProps: story.content.hero[0],
          showBorderRadius: false,
        },
      },
      revalidate: 60,
    }
  } catch {
    return { notFound: true } as const
  }
}
const getStaticPropsfn: GetStaticProps = async ({
  params,
  preview = false,
}: GetStaticPropsContext) =>
  await getStoryProps(params?.slug as string, preview)

export const getStaticProps = traceFunction(
  'brandpage.getStaticProps',
  getStaticPropsfn,
)

export type BrandPageProps = InferGetStaticPropsType<typeof getStoryProps>
